import React from "react";
import { DropdownButton, Dropdown, Row, Col } from "react-bootstrap";
import ReactCountryFlag from 'react-country-flag';
import getCountryISO2 from 'country-iso-3-to-2';
import { REGIONS } from '../data/dataset';

// REGIONS only contains regions that actually have readings, but a few of them
// (the OWID "Africa" aggregate, were it ever included) have no ISO-2 equivalent,
// so only draw a flag when the code maps to a real country.
const CountryLabel = ({ country, placeholder }) => {
    if (!country) return placeholder;

    const iso2 = getCountryISO2(country.iso_code);

    return (
        <>
            {iso2 ?
                <div style={{ width: '1.5em', height: '1.5em', borderRadius: '50%', overflow: 'hidden', position: 'relative', display: "inline-block", marginRight: "10px" }} className="border">
                    <ReactCountryFlag
                        svg
                        countryCode={iso2}
                        style={{
                            position: 'absolute',
                            top: '30%',
                            left: '30%',
                            marginTop: '-50%',
                            marginLeft: '-50%',
                            fontSize: '2em',
                            lineHeight: '2em',
                        }} />
                </div> : ''}
            {country.location}
        </>
    )
}

const SelectCountries = ({ selectedCountry1, selectedCountry2, countrySelect1, countrySelect2 }) => {

    const options = (onSelect) => REGIONS.map((country) => (
        <Dropdown.Item
            key={country.iso}
            onClick={() => onSelect({ iso_code: country.iso, location: country.region })}>
            {country.region}
        </Dropdown.Item>
    ))

    return (
        <Row className="mt-2 mb-4 countries-row">
            <Col xs="auto">
                <Row >
                    <Col><h5 className="select-country--title" >Select Country/Region 1 </h5></Col>
                </Row>
                <DropdownButton
                    title={<CountryLabel country={selectedCountry1} placeholder="Choose country" />}
                    className="country-select" >
                    {options(countrySelect1)}
                </DropdownButton>
            </Col>
            <Col xs="auto">
                <Row >
                    <Col>

                        <h5 className="select-country--title">Select Country/Region 2 </h5></Col>
                </Row>
                <DropdownButton
                    title={<CountryLabel country={selectedCountry2} placeholder="Choose country" />}
                    className="country-select" >
                    {options(countrySelect2)}
                </DropdownButton>
            </Col>
        </Row>
    )
}
export default SelectCountries;
